import React from 'react';

export interface AppStateContextProps {
  isCommitRunning: boolean;
  setIsCommitRunning: (val: boolean) => void;
}

export const AppStateContext = React.createContext<AppStateContextProps>({
  isCommitRunning: false,
  setIsCommitRunning: () => null,
});

export default AppStateContext;
